import { Button, InputText } from "@sellar-io/components";
import { PushNotificationDevicesGetResponseType } from "@sellar-io/api-v2/types";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../components/modal/Dialog";
import { InputLabel, InputContainer } from "@sellar-io/components";
import { usePushNotificationDeviceUpdate } from "../../../hooks/api/v2/pushNotification/usePushNotificationDeviceUpdate";
import { useState } from "react";

export const PushNotificationDeviceRenameModal = ({
  onDismiss,
  device,
  active,
}: {
  onDismiss: () => void;
  device: PushNotificationDevicesGetResponseType[number];
  active: boolean;
}) => {
  const deviceNameUpdateMutation = usePushNotificationDeviceUpdate(device.id);
  const [deviceName, setDeviceName] = useState(device.deviceName);

  const updateDeviceName = () => {
    deviceNameUpdateMutation.mutate(
      {
        deviceName,
      },
      {
        onSuccess: () => {
          onDismiss();
        },
      },
    );
  };

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={"Rename device"}
      />
      <DialogContent>
        <InputLabel className="mb-2">Device name</InputLabel>
        <InputContainer>
          <InputText
            value={deviceName}
            onChange={(e) => setDeviceName(e.target.value)}
          />
        </InputContainer>
      </DialogContent>
      <DialogCTA>
        <Button
          onClick={() => updateDeviceName()}
          loading={deviceNameUpdateMutation.isPending}
        >
          Confirm
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
